import React from 'react';
import { motion } from 'framer-motion';

import {
  SectionTitle,
  Heading,
  ParaText,
  BlueText,
} from '../styles/Global.styled.js';

import {
  SkillsSection,
  SkillsWrapper,
  SkillsGrid,
  SkillsTextBlock,
  SkillsCardContainer,
  SkillsCard,
} from '../styles/MySkills.styled.js';

import { Skills } from '../utils/Data.js';
import { fadeInLeftVariant, fadeInRightVariant } from '../utils/Variants.js';

function MySkills() {
  return (
    <SkillsSection id="Skills">
      <SkillsWrapper>
        <SectionTitle align="center">My Skills</SectionTitle>
        <Heading as="h2" size="h2" align="center">
          What <BlueText>I can do</BlueText>
        </Heading>

        <SkillsGrid>
          <motion.div
            variants={fadeInLeftVariant}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <SkillsCardContainer>
              {Skills.map((skill) => (
                <SkillsCard key={skill.id}>
                  <span style={{ fontSize: '2.5rem', color: skill.color, display: 'inline-flex' }}>
                    {skill.icon}
                  </span>
                  <h4>{skill.tech}</h4>
                </SkillsCard>
              ))}
            </SkillsCardContainer>
          </motion.div>

          <SkillsTextBlock
            as={motion.div}
            variants={fadeInRightVariant}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <ParaText bottom="1.5rem">
              A results-driven software developer with over five years of
              experience in building high-quality, user-centric applications.
              Specializes in Flutter, React, and Node.js, with strong expertise
              in designing and integrating scalable frontend and backend
              solutions.
            </ParaText>

            <ParaText bottom="1.5rem">
              Focused on delivering intuitive, high-performance user experiences
              while maintaining clean, efficient, and maintainable code. Known
              for a keen eye for detail and a problem-solving mindset,
              consistently delivering polished products that align with business
              goals and user expectations.
            </ParaText>

            <ParaText>
              Experienced in developing cross-platform mobile applications with
              Flutter, building dynamic web interfaces using React, and
              optimizing backend services with Node.js. Passionate about
              continuous learning and taking on challenges that drive technical
              and professional growth.
            </ParaText>
          </SkillsTextBlock>
        </SkillsGrid>
      </SkillsWrapper>
    </SkillsSection>
  );
}

export default MySkills;
